import React, { useEffect, useState, useContext } from "react";
import "../styles/adminLocal.scss";
import AdminLocalMainInfo from "../components/AdminLocal/AdminLocalMainInfo";
import AdminLocalContracts from "../components/AdminLocal/AdminLocalContracts";
import AdminLocalState from "../components/AdminLocal/AdminLocalState";
import AdminLocalContact from "../components/AdminLocal/AdminLocalContact";
import Calificaciones from "../components/AdminLocal/AdminLocalCalificaciones";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Toggle from "react-toggle";
import { axiosInstanceMain } from "../utils/axiosGlobalUtils";
import ComboBox from "../components/Common/ComboBox";
import { useNavigate, useParams } from "react-router-dom";
import SnackBarUtils from "../utils/SnackBarUtils";
import {
  Container,
  Divider,
  Paper,
  useMediaQuery,
  useTheme,
  styled,
} from "@mui/material";
import { getLocal as getLocalVendedor } from "./AbmLocalPage/services/locales.service";
import FormLocales from "./AbmLocalPage/components/Form";
import { connect } from "react-redux";
import Navbar from "../components/Navbar";
import { RolType } from "../components/Navbar/Sidebar/SidebarItems";
import AdminLocalHistorias from "../components/AdminLocal/AdminLocalHistorias";
import { format } from "date-fns";
import Footer from "./Home/components/Footer";
import useLocal from "./Products/hooks/locals.hook";
import DialogShareLink from "./DialogCopySharelink";
import { TenantsContext } from "../context/tenants.context";
import { LocalAdminDTO } from "../dto/LocalDTO";

const ContectTextArea = styled("div")({});

const ContentObservaciones = styled("div")({ margin: "0 1rem" });

const ActionsGroup = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  margin: "0rem 1rem",
  gap: "10px",
  flexWrap: "wrap",
});

const Info = styled("div")({
  fontSize: "calc(15px + 1vmin)",
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
});

const ContentSwitch = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
});

const ContentTables = styled("div")({
  display: "flex",
  alignItems: "flex-start",
  gap: "10px",
  padding: "0 10px",
  "@media (max-width: 425px)": {
    flexWrap: "wrap",
  },
});

const AdminLocalPage: React.FC = (props: any) => {
  const [premise, setPremise] = useState<LocalAdminDTO>();
  const [fechaAlta, setFechaAlta] = useState<Date | null>();
  const [stickerDate, setStickerDate] = useState<Date | null>();
  const [important, setImportant] = useState<boolean>(false);
  const [virtual, setVirtual] = useState<boolean>(false);
  const navigate = useNavigate();
  const [autoApproval, setAutoApproval] = useState<number>(0); // 0 no definido - 1 Si - 2 No
  const [observations, setObservations] = useState<string>();
  const [soloLectura, setSoloLectura] = useState<boolean>(true);
  const [localAEditar, setLocalAEditar] = useState<any>(null);
  const [openDialogShareLink, setOpenDialogShareLink] =
    useState<boolean>(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isAdmin = props.logged.userLogged.roles.includes(RolType.ADMIN);
  const { token } = props.logged?.userLogged;
  const { tenant } = useContext(TenantsContext);

  let { id } = useParams<{ id: string }>();
  const { shareLink, shareLinkMinorista } = useLocal(id, token);

  useEffect(() => {
    if (id) getLocal(id);
  }, [id]);

  const getLocal = async (idLocal: string | number) => {
    axiosInstanceMain
      .get(`/admin/${tenant.path}/locales/${idLocal}`)
      .then((result) => {
        setPremise(result.data.data);
      })
      .catch((error) => {
        console.log(error);
        navigate("/abm-locales");
      });
  };

  const handleCopyShareLink = (link: string) => {
    navigator.clipboard.writeText(link);
    SnackBarUtils.success("Enlace copiado con éxito");
  };

  useEffect(() => {
    setFechaAlta(
      premise?.fechaAltaFormateada
        ? new Date(`${premise.fechaAltaFormateada}T00:00`)
        : null
    );
    setStickerDate(
      premise?.fechaPusoStickerFormateada
        ? new Date(`${premise.fechaPusoStickerFormateada}T00:00`)
        : null
    );
    setImportant(premise?.importante || false);
    premise?.virtual && setVirtual(premise?.virtual);
    premise && premise.aprobarProductosAuto === null
      ? setAutoApproval(0)
      : premise?.aprobarProductosAuto === true
      ? setAutoApproval(1)
      : setAutoApproval(2);
    setObservations(
      premise?.observaciones
        ?.replaceAll('"', "")
        .replaceAll("\\n", String.fromCharCode(13, 10))
    );
  }, [premise]);

  const changeStickerDate = (value: Date) => {
    setStickerDate(value);
    axiosInstanceMain
      .patch(
        `/admin/${tenant.path}/locales/${premise?.idLocal}/fechapusosticker`,
        format(value, "yyyy-MM-dd")
      )
      .then(() => {
        setStickerDate(value);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const changeImportant = (e: any) => {
    let value = !important;
    axiosInstanceMain
      .patch(
        `/admin/${tenant.path}/locales/${premise?.idLocal}/importante`,
        value
      )
      .then(() => {
        setImportant(value);
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  const changeVirtual = (e: any) => {
    let value = !virtual;
    axiosInstanceMain
      .patch(`/admin/${tenant.path}/locales/${premise?.idLocal}/virtual`, value)
      .then(() => {
        setVirtual(value);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const changeAutoApproval = (e: any) => {
    const selectedValue = e.target.value;
    let value =
      selectedValue === "0" ? null : selectedValue === "1" ? true : false;

    axiosInstanceMain
      .patch(
        `/admin/${tenant.path}/locales/${premise?.idLocal}/aprobar-productos-auto`,
        value
      )
      .then(() => {
        setAutoApproval(selectedValue);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const changeObservations = (e: any) => {
    axiosInstanceMain
      .patch(
        `/admin/${tenant.path}/locales/${premise?.idLocal}/observaciones`,
        e.target.value
      )
      .then(() => {
        setObservations(e.target.value);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getLocalAEditar = async () => {
    try {
      if (!premise) return null;
      const res = await getLocalVendedor(premise.idLocal, tenant);
      setLocalAEditar(res.data.data);
      return res.data.data;
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Navbar
        title={
          isMobile
            ? `${premise?.nombre} ID: ${premise?.idLocal}`
            : `Admin Local: ${premise?.nombre} ID: ${premise?.idLocal}`
        }
        searchBar={true}
      />
      {!soloLectura && localAEditar ? (
        <Container maxWidth="md">
          {isMobile ? (
            <FormLocales
              setSoloLectura={setSoloLectura}
              local={localAEditar}
              props={props}
              getLocal={getLocal}
              setLoading={() => {}}
            />
          ) : (
            <Paper variant="outlined" sx={{ px: { md: "3em", xs: "0.5em" } }}>
              <FormLocales
                setSoloLectura={setSoloLectura}
                local={localAEditar}
                props={props}
                getLocal={getLocal}
                setLoading={() => {}}
              />
            </Paper>
          )}
        </Container>
      ) : (
        <>
          <AdminLocalMainInfo
            premise={premise}
            setSoloLectura={setSoloLectura}
            getLocalAEditar={getLocalAEditar}
          />
          <ContentTables>
            <AdminLocalContact premise={premise} />
            {!isMobile && (
              <Divider
                orientation="vertical"
                style={{ margin: "0px 20px", height: "220px" }}
              />
            )}
            <Calificaciones idLocal={premise?.idLocal} isAdmin={true} />
          </ContentTables>
          <AdminLocalState premise={premise} setPremise={setPremise} />
          <br />
          <ActionsGroup>
            <Info>
              Fecha Alta: {fechaAlta && format(fechaAlta, "dd/MM/yyyy")}
            </Info>
            <ContentSwitch>
              <Info>Puso Sticker</Info>
              <DatePicker
                className="premise-info-child"
                // selected={
                //   typeof stickerDate?.getMonth === "function" ? stickerDate : null
                // }
                //selected={stickerDate}
                onChange={(dt: Date) => changeStickerDate(dt)}
                value={stickerDate ? format(stickerDate, "dd/MM/yyyy") : ""}
              />
            </ContentSwitch>
            <ContentSwitch>
              <Info>Importante</Info>
              <Toggle
                id="important"
                className="premise-info-child"
                checked={important}
                onChange={changeImportant}
              />
            </ContentSwitch>
            <ContentSwitch>
              <Info>Virtual</Info>
              <Toggle
                id="checked"
                className="premise-info-child"
                checked={virtual}
                onChange={changeVirtual}
              />
            </ContentSwitch>
            {shareLink && (
              <button
                className="btn btn-primary"
                onClick={() =>
                  shareLinkMinorista
                    ? setOpenDialogShareLink(true)
                    : handleCopyShareLink(shareLink)
                }
              >
                Copiar link catálogo
              </button>
            )}
            <div className="premise-info-child">
              <ComboBox
                label="Aprobación automática"
                styles="premise-info-child"
                htmlFor="automaticApproval"
                value={autoApproval}
                onChange={changeAutoApproval}
                options={[
                  { value: 1, name: "Sí" },
                  { value: 2, name: "No" },
                  { value: 0, name: "No Definido" },
                ]}
              />
            </div>
          </ActionsGroup>
          <label className="premise-info">Contratos</label>
          <AdminLocalContracts
            premise={premise}
            updateLocal={getLocal}
            props={props}
          />
          <label className="premise-info">Historias</label>
          {premise && <AdminLocalHistorias premise={premise} />}
          <ContentObservaciones>
            {/* <div className="form-group premise-info"> */}
            <Info>Observaciones</Info>
            <ContectTextArea>
              <textarea
                className="form-control"
                rows={3}
                onBlur={changeObservations}
                value={observations}
                onChange={(e) => {
                  setObservations(e.target.value);
                }}
              >
                {/* {observations} */}
              </textarea>
            </ContectTextArea>
            {/* </div> */}
          </ContentObservaciones>
          <DialogShareLink
            open={openDialogShareLink}
            setOpen={setOpenDialogShareLink}
            shareLink={shareLink}
            shareLinkMinorista={shareLinkMinorista}
            handleCopyShareLink={handleCopyShareLink}
          />
        </>
      )}
      <br />
      <Footer />
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    logged: state.logged,
  };
};

export default connect(mapStateToProps)(AdminLocalPage);
